<app-service-settings-common
    [defaultData]="store.formsCardSettings()"
    [title]="'service.settings.forms.title'"
>
    <ng-template #additionalContent>
        <p-divider></p-divider>
        <app-table
            [items]="$any(store.forms())"
            [columns]="columns"
            translatePrefix="service.settings.forms."
            [hideCheckboxes]="true"
        >
            <ng-template pTemplate="useInThisService" let-item="item">
                <app-check-input
                    [id]="item.id.toString()"
                    [form]="form"
                    [showLabel]="false"
                ></app-check-input>
            </ng-template>
        </app-table>
    </ng-template>

    <ng-template #footer>
        <app-action-buttons
            (primaryClickEvent)="save()"
            (secondaryClickEvent)="cancel()"
        ></app-action-buttons>
    </ng-template>
</app-service-settings-common>
